/** Paths to array fields in the content type schema, including nested objects. */
export function getArrayKeyPaths(schema: any): string[] {
  const paths = new Set<string>();

  const visit = (nodes: any[], parent = ''): void => {
    if (!Array.isArray(nodes)) return;

    for (const node of nodes) {
      if (!node?.key) continue;
      const path = parent ? `${parent}.${node.key}` : node.key;
      if (node.type === 'array') paths.add(path);
      visit(node.type === 'array' ? node.items?.properties : node.properties, path);
    }
  };

  visit(Array.isArray(schema) ? schema : schema?.properties);
  return [...paths];
}

export function displayArrayKeyPath(path: string): string {
  const lastSeparator = path.lastIndexOf('.');
  return lastSeparator < 0 ? path : `…${path.slice(lastSeparator + 1)}`;
}
